import { Network } from '@/hooks/network/useNetwork'
import { InferProbabilityDict } from '@/services/bayesianApi/inferenceModels'
import { Connection, Variable } from '@/types/variable'

export const convertProbabilityDictToProbabilities = ({
  network,
  probabilityDict,
}: {
  network: Network
  probabilityDict: InferProbabilityDict
}) =>
  Object.entries(probabilityDict).map(([variableId, probabilities]) => {
    const variable = network.variables.find((v) => v.id === variableId)

    if (!variable) {
      throw new Error(`Variable with id ${variableId} not found in network`)
    }

    return {
      variableId: variable.id,
      variableName: variable.name,
      probability: probabilities.map((p, i) => ({
        state: variable.stateIds[i],
        probability: p,
      })),
    }
  })

export const convertInboundArrowsToParentIds = (inboundArrows: Connection[]) =>
  inboundArrows.map((c) => c.variableId)

export const getFaultIndices = (variable: Variable) =>
  variable.faults?.map((f) => variable.stateIds.indexOf(f)) ?? []

export type AssumptionSetProbabilities = ReturnType<
  typeof convertProbabilityDictToProbabilities
>
